/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_1_TInputs */

const en_cp_cmp_1_t = /** @type {(inputs: Cp_Cmp_1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp 6–20M grants, national proposal selection, monitoring, KMI Expo.`)
};

const id_cp_cmp_1_t = /** @type {(inputs: Cp_Cmp_1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendanaan Rp 6–20 jt, seleksi proposal nasional, monev, KMI Expo.`)
};

/**
* | output |
* | --- |
* | "Rp 6–20M grants, national proposal selection, monitoring, KMI Expo." |
*
* @param {Cp_Cmp_1_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_1_t = /** @type {((inputs?: Cp_Cmp_1_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_1_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_1_t(inputs)
	return en_cp_cmp_1_t(inputs)
});